import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    maxWidth: '730px',
    minWidth: '299px',
    width: '100%',
    alignSelf: 'center',
    marginBottom: '90px',
  },
  pageTitle: {
    [theme.breakpoints.down('sm')]: {
      marginTop: '15px',
    },
    [theme.breakpoints.down('xs')]: {
      fontSize: '23px',
    },
    fontSize: '33px',
    fontWeight: '400',
    color: '#fff',
    marginBottom: '24px',
  },
  selectContainer: {
    display: 'flex',
    gap: '12px',
    alignItems: 'center',
    maxWidth: '450px',
  },
  select: {
    width: 'fit-content',
    backgroundColor: '#292929',
    borderRadius: '8px!important',
    fontSize: '14px!important',
    '& .MuiSelect-select': {
      alignItems: 'center!important',
      minHeight: '0!important',
      display: 'flex!important',
      height: '20px!important',
      border: '1px solid #404040!important',
      borderRadius: '8px!important',
      padding: '7px 32px 7px 12px!important',
      color: '#fff!important',
    },
    '&.MuiOutlinedInput-root': {
      minHeight: '0px!important',
      '& fieldset': {
        border: 'none',
      },
      '&:hover fieldset': {
        borderColor: '#404040',
      },
      '&.Mui-focused fieldset': {
        border: 'none',
      },
    },
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
      border: 'none!important',
    },
  },
  selectPaper: {
    marginTop: '6px!important',
    border: '1px solid #404040!important',
    '& .MuiList-root': {
      padding: '0px!important',
      '& .MuiMenuItem-root': {
        fontSize: '13px',
        padding: '0 12px!important',
        borderRadius: '0!important',
        color: '#fff!important',
        '&:hover': {
          backgroundColor: '#232323!important',
        },
      },
    },
  },
  searchbar: {
    '&::placeholder': {
      color: '#888888',
      fontSize: '14px',
      fontWeight: '400',
      border: 'none!important',
    },
    width: '470px',
    minWidth: '0px',
    maxWidth: '-webkit-fill-available',
    height: '36px',
    borderRadius: '8px',
    padding: '8px 12px',
    color: '#fff',
    backgroundColor: '#292929',
    border: '1px solid #404040',
    fontSize: '14px',
    fontWeight: '400',
    outline: 'none',
  },
  autocomplete: {
    maxWidth: '450px',
    marginTop: '12px',
    '& .MuiPaper-root-MuiAutocomplete-paper': {
      fontSize: '10px!important',
    },
    '& .MuiOutlinedInput-notchedOutline': {
      border: 'none',
    },
    '&:hover .MuiOutlinedInput-notchedOutline': {
      border: 'none',
    },
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
      border: 'none',
    },
    '& .MuiInputBase-sizeSmall': {
      padding: '8px 12px !important',
      gap: '4px',
    },
    '& .MuiAutocomplete-tag': {
      margin: '0',
    },
    '& .MuiAutocomplete-clearIndicator': {
      display: 'none',
    },
    '& .MuiInputBase-input': {
      fontSize: '14px',
      padding: '0!important',
      color: '#fff!important',
      '&::placeholder': {
        color: '#757575!important',
        opacity: '1!important',
      },
    },
  },
  autocompletePaper: {
    '& .MuiAutocomplete-noOptions': {
      [theme.breakpoints.down('xs')]: {
        fontSize: '13px',
      },
      fontSize: '14px',
      padding: '8px 12px',
      marginTop: '6px',
      border: '1px solid #404040',
      borderRadius: '8px',
    },
  },
  autocompleteList: {
    marginTop: '6px!important',
    border: '1px solid #404040!important',
    borderRadius: '8px!important',
    padding: '0!important',
    '& .MuiAutocomplete-option': {
      [theme.breakpoints.down('xs')]: {
        fontSize: '13px!important',
      },
      fontSize: '14px',
      minHeight: '36px!important',
      padding: '8px 12px!important',
      '&:hover': {
        backgroundColor: '#232323!important',
      },
    },
  },
  pagination: {
    fontSize: '1.5rem',
    fontWeight: '500',
    color: '#ffffff',
    margin: '1rem 0',
  },
  infiniteScroll: {
    marginTop: '18px',
  },
  card: {
    display: 'flex',
    justifyContent: 'space-between',
    gap: '12px',
    minHeight: '58px',
    border: '1px solid #404040',
    backgroundColor: '#161616',
    padding: '12px',
    borderRadius: '8px',
    color: '#fff',
    fontSize: '14px',
    fontWeight: '400',
    marginBottom: '12px',
    [theme.breakpoints.down('xs')]: {
      fontSize: '12px',
    },
  },
  clickableCard: {
    '&:hover': {
      cursor: 'pointer',
    },
  },
  cardLabel: {
    display: 'flex',
    alignItems: 'center',
    maxWidth: '440px',
    gap: '8px',
  },
  cardActions: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    [theme.breakpoints.down('xs')]: {
      flexDirection: 'column-reverse',
      alignItems: 'flex-end',
    },
  },
  cardTimestampContainer: {
    display: 'flex',
    alignItems: 'flex-end',
    gap: '8px',
  },
  cardTimestamp: {
    color: '#888888',
    display: 'flex',
    fontSize: '12px',
    justifyContent: 'flex-end',
    alignItems: 'center',
    textWrap: 'balance',
    minWidth: '64px',
    textAlign: 'right',
    whiteSpace: 'nowrap',
    [theme.breakpoints.down('xs')]: {
      fontSize: '11px',
    },
  },
  cardStatus: {
    fontSize: '13px',
    textWrap: 'nowrap',
    [theme.breakpoints.down('xs')]: {
      fontSize: '12px',
    },
  },
  cardButtonGrid: {
    display: 'flex',
    gap: '8px',
  },
  cardButton: {
    display: 'flex',
    height: 'fit-content',
    cursor: 'pointer',
  },
  circularProgress: {
    color: '#fff',
  },
  ttiCardGrid: {
    borderRadius: '8px !important',
    gap: '16px',
    overflowY: 'auto',
    scrollBehavior: 'smooth',
    '&::-webkit-scrollbar': {
      width: '8px',
      marginRight: '5px',
    },
    '&::-webkit-scrollbar-track': {
      background: '#292929',
      borderRadius: '10px',
    },
    '&::-webkit-scrollbar-thumb': {
      background: '#404040',
      borderRadius: '10px',
    },
    '&::-webkit-scrollbar-thumb:hover': {
      background: '#9A9A9A',
    },
    '&::-webkit-scrollbar-thumb:active': {
      background: '#9A9A9A',
    },
  },
  dragAndDropText: {
    [theme.breakpoints.down('xs')]: {
      fontSize: '10px',
    },
    fontWeight: '300',
    fontSize: '14px',
    color: '#9A9A9A',
    textAlign: 'center',
  },
  selectModelButton: {
    [theme.breakpoints.down('xs')]: {
      width: `9rem`,
      height: '9rem',
      gap: '0.5rem',
      fontSize: '10px',
    },
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '1rem',
    width: `10rem`,
    height: '10rem',
    borderWidth: 2,
    backgroundColor: '#292929',
    border: '1px dashed #404040',
    borderRadius: '8px',
    //transition: "border .24s ease-in-out",
    fontSize: '14px',
    cursor: 'pointer',
  },
  addButtonImg: {
    [theme.breakpoints.down('xs')]: {
      fontSize: '2rem',
    },
    fontSize: '54px !important',
    color: '#9A9A9A',
  },
  ttiCard: {
    [theme.breakpoints.down('xs')]: {
      width: `9rem`,
      height: '9rem',
      fontSize: '1rem',
    },
    flex: '0 0 auto',
    width: `10rem`,
    height: '10rem',
    backgroundColor: '#161616',
    borderRadius: '0.5rem',
    color: '#fff',
    fontSize: '1.5rem',
    fontWeight: '400',
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
  },
  ttiCardCoverImg: {
    [theme.breakpoints.down('xs')]: {
      width: `9rem`,
      height: '9rem',
    },
    position: 'absolute',
    zIndex: '0',
    borderRadius: '0.5rem',
    width: `10rem`,
    height: '10rem',
    objectFit: 'cover',
  },
  ttiCardContent: {
    position: 'absolute',
    width: '100%',
    zIndex: '2',
    display: 'flex',
    flexDirection: 'column',
    alightItems: 'center',
    gap: '3px',
    borderRadius: '0 0 0.5rem 0.5rem',
    bottom: '0',
    backgroundColor: 'rgb(0, 0, 0, 0.6)',
    padding: '5px',
  },
  ttiCardContentFirstRow: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    width: '100%',
  },
  ttiCardLabel: {
    [theme.breakpoints.down('xs')]: {
      fontSize: '0.75rem',
      lineHeight: '0.8rem',
    },
    display: '-webkit-box',
    width: 'auto',
    fontSize: '0.85rem',
    lineHeight: '0.9rem',
    overflowWrap: 'anywhere',
    WebkitLineClamp: 2,
    WebkitBoxOrient: 'vertical',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  ttiCardTimestamp: {
    //marginTop: "3.3rem",
    // alightItems: 'flex-end',
    display: 'flex',
    // marginLeft: '0.3rem',
    justifyContent: 'space-between',
    fontSize: '0.65rem',
    color: '#d3d3d3',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    //whiteSpace: "nowrap",
    [theme.breakpoints.down(476)]: {
      fontSize: '0.6rem',
    },
  },
  ttiDownloadButton: {
    position: 'absolute',
    top: '9px',
    right: '1.8rem',
    cursor: 'pointer',
  },
  modelDeleteButton: {
    position: 'absolute',
    top: '8px',
    right: '0.4rem',
    cursor: 'pointer',
  },
  modelDeleteIcon: {
    color: '#fff',
    width: '18px',
    filter: 'drop-shadow(0 0 4px rgba(0,0,0,0.6))',
  },
  ttiCardStatus: {
    textAlign: 'center',
    display: 'flex',
    alignItems: 'center',
    fontSize: '0.8rem',

    [theme.breakpoints.down('xs')]: {
      maxWidth: '4rem',
      fontSize: '10px',
    },
  },
  ttiCardEditIcon: {
    [theme.breakpoints.down('xs')]: {
      width: '0.9rem!important',
    },
    width: '1rem!important',
    height: 'auto!important',
    marginLeft: '2px',
    marginBottom: '1px',
    cursor: 'pointer',
  },
}));

export { useStyles };
